module.exports = __webpack_public_path__ + "img/CRT_Sword-001.9617f715.png";